import { SxProps } from '@mui/material'
import { STYLE_UNITS } from '@/styles'
import { modalDimensions } from '../Modal'
import { swiperClasses } from '../Swiper'

interface ImageGalleryModalStyles {
  wrapper: SxProps
  galleryImages: SxProps
}

export const imageGalleryModalStyles: ImageGalleryModalStyles = {
  wrapper: {
    width: {
      xs: `calc(100vw - ${modalDimensions.padding * STYLE_UNITS.SPACING_MULTIPLIER * 2}px)`,
      md: 650,
    },
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  galleryImages: {
    width: { xs: '100%', md: 650 },
    height: { xs: 225, md: 366 },
    aspectRatio: '16/9',

    [`.${swiperClasses.swiperImageSliderImage}`]: {
      borderRadius: 2,
    },
  },
}
